module.exports = __webpack_public_path__ + "img/is_use2.c69b962c.png";